module.exports = __webpack_public_path__ + "img/view-light.e3d1713a.svg";